<template>
  <div style="padding: 12px;">
    <el-card class="box-card pd-header" shadow="hover" >
      <div slot="header" class="clearfix">
        <p-button class="pull-right" type="success" size="sm" icon>
          <i class="fa fa-download" @click="downloadProcessDefinition"></i>
        </p-button>
        <p-button class="pull-right" type="warning" size="sm" icon>
          <i class="fa fa-archive" @click="confirmArchive" title="Archive Camunda Deployment"></i>
        </p-button>
        <p-button class="pull-right" type="danger" size="sm" icon :disabled="hasInstanceCount">
          <i class="fa fa-times" @click="confirmDelete" title="Delete Camunda Deployment"></i>
        </p-button>
        <div class="text item">
          <p style="padding-top:7px"><strong>Name: </strong> <span>{{ data.name }}</span></p>
        </div>
      </div>
      <div class="text item">
        <p><strong>Deployment ID: </strong> <span>{{ data.id }}</span></p>
      </div>
      <div class="text item">
        <p><strong>Process Definition ID: </strong> <span>{{ data.processDefinitions[0].id }}</span></p>
      </div>
      <div class="text item">
        <p><strong>Version: </strong> <span>{{ data.processDefinitions[0].version }}</span></p>
      </div>
      <div class="text item">
        <p><strong># Instances: </strong> <span>{{ instanceCount }}</span></p>
      </div>
      <div style="text-align: right;">
        <button v-if="hasInstanceCount > 0" @click="viewJobs(data.processDefinitions[0].id)" class="btn btn-fill btn-info btn-wd">View Jobs</button>
      </div>
    </el-card>
  </div>
</template>

<script>
  import PButton from 'src/components/UIComponents/Button.vue'
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import {mapGetters} from 'vuex'
  import Constants from 'src/utilities/constants'

  export default {
    props: ['data'],
    components: {
      PButton,
    },
    computed: {
      ...mapGetters({
        instanceCount: 'camunda/processDefinitionInstanceCount',
      }),
      hasInstanceCount() {
        return this.instanceCount > 0
      },
      canRead() {
        return this.$can('read', Permissions.CAMUNDA)
      },
      canEdit() {
        return this.$can('edit', Permissions.CAMUNDA)
      }
    },
    data() {
      return {
        toDelete: null
      }
    },
    methods: {
      async downloadProcessDefinition(processDefinition) {
        await this.$store.dispatch('camunda/fetchProcessDefinitionXml', processDefinition.id)
        await this.$store.dispatch('camunda/downloadProcessDefinition', processDefinition)
      },
      confirmArchive() {
        this.$eventHub.$emit('show-modal-2', 'Confirm Archive Deployment', this.data, '600px')
      },
      confirmDelete() {
        this.toDelete = this.data.id
        const payload = {
          message: 'Are you sure you want to delete <strong>' + this.data.name + '</strong>? This will permanently delete any process definition(s) included in the deployment. Deployments with process definitions that have running processes cannot be deleted.',
          entity: this.data,
          delete: this.delete,
          showButton: true
        }
        this.$eventHub.$emit('show-modal-2', 'Confirm Delete', payload, '600px')
      },
      async delete() {
        const response = await this.$store.dispatch('camunda/deleteDeployment', this.toDelete, {root: true})
        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          notifySuccess(this, 'Deployment Deleted Successfully')
          this.$eventHub.$emit('camundaDeploymentDeleted')
        } else {
          notifyError(this, 'Error Deleting Deployment')
        }
      },
      viewJobs(processDefinitionId) {
        this.$store.commit('jobs/search/resetQuery')
        this.$store.commit('jobs/search/resetResults')
        this.$store.set('jobs/search/query@status', [Constants.STATUSES.PENDING, Constants.STATUSES.ON_HOLD, Constants.STATUSES.BLOCKED, Constants.STATUSES.IN_PROGRESS])
        this.$store.set('jobs/search/query@processDefinitionId', processDefinitionId)
        this.$store.set('jobs/search/query@departmentIds', [this.data.departmentId])
        this.$store.dispatch('jobs/search/fetchResults')
        this.$router.push({path: '/jobs/search'})
        this.$emit('close')
      }
    },
    mounted() {
      this.$store.dispatch('camunda/fetchProcessDefinitionWithProcessInstanceCount', this.data.processDefinitions[0].id)
    }
  }
</script>

<style scoped>
  .text {
    font-size: 14px;
  }
  .item {
    margin-bottom: 18px;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
</style>
